import SideControlsPage from "Layouts/SideControls/SideControlsPage";
import React from "react";
import ConfigNavigation, { ConfigRoutes } from "./ConfigNavigation";


export default function Config() {
    return (
        <SideControlsPage
            mainContent={<ConfigRoutes />}
            enableMinimize
            containerOffsetPixels={64}
            drawerContent={<ConfigNavigation />}
            drawerLocation="left"
            mainGridAlignItems="stretch"
            mainGridJustify="flex-start"
            mainGridSpacing={0}
            mainSx={{
                padding:0
            }}
        />
    );
}
